import { logger } from "@pufflig/logger";
import { SQLAgentInterruptPayload, SQLAgentResumeMessage, v2 } from "@pufflig/prompt-studio-types";
import { safeStringify, shortUID } from "@pufflig/prompt-tools";
import { PromptbookWebRuntime } from "@pufflig/promptbook-runtime";
import { getThreadParams, setThreadValue } from "../threads/threads";

export const handleLocalSQLInterrupt = async (
  threadId: string,
  interrupt: SQLAgentInterruptPayload,
  runtime: PromptbookWebRuntime,
  connection: WebSocket,
) => {
  if (interrupt.client_tool !== "run_sql") return { toolResult: { error: "" }, error: "Unknown interrupt type" };

  const sql = interrupt.args.sql;

  logger.debug(`queryLocalDB: Running SQL: ${sql}`);

  const res = await runtime.db.query(sql);

  const resultId = shortUID("r");
  let tableSchema = null;

  const params = getThreadParams(threadId);
  const resultName = params.resultName;

  // we should create a wrapper for this (generate a table schema from a result)
  if (res?.success && res.success.length > 0) {
    const file = new File([safeStringify(res.success)], `${resultName}.json`, {
      type: "application/json",
    });

    const { success, error } = await runtime.db.createTableFromFile(resultId, file);

    if (!success || error) {
      return {
        toolResult: null,
        error: `Internal: Failed to create local table: ${error}`,
      };
    }

    const { success: _tableSchema } = await runtime.db.describeTable(success.tableName);
    tableSchema = _tableSchema;
  }
  // ---

  logger.debug(`queryLocalDB(${resultName}): Table schema: ${safeStringify(tableSchema || {})}`);

  const toolResult = {
    success: {
      resultName: resultName,
      resultType: "table",
      resultId,
      createdAt: new Date().toISOString(),
      schema: tableSchema,
    } as v2.ResultMetadata,
  };

  const table = res?.success;

  // could be expensive!
  if (table) {
    setThreadValue(threadId, "table", JSON.parse(safeStringify(table)));
  }

  if (tableSchema) {
    setThreadValue(threadId, "tableSchema", tableSchema);
  }

  if (toolResult) {
    const payload: SQLAgentResumeMessage = {
      type: "sql_agent_resume",
      threadId,
      toolResult: toolResult,
    };

    connection.send(safeStringify(payload));
  }
};
